import { SearchBaseModel } from '../commonModels';


export class PricelistSearchModel extends SearchBaseModel {
  public PricelistId: number;
  public IsActive: boolean;
  public GarageId: number;
  public CustomerId: number;


  constructor() {
    super();
    this.PricelistId = null;
    this.IsActive = null;
    this.GarageId = null;
    this.CustomerId = null;
  }
}
